import LocalStorageService from '../../utility/LocalStorageService';
import loadLocalUserStorage from '../actions/localStorage';
import { fetchSessionData } from '../slices/sessionSlice';

const localStorageMiddleware = (storeAPI) => (next) => (action) => {
  const result = next(action);

  if (fetchSessionData.fulfilled.match(action)) {
    const [sessionInfoResponse] = action.payload;
    const { session } = sessionInfoResponse;
    if (!session) {
      return result;
    }

    const { userId } = session;
    const localStorageUserId = LocalStorageService
      .getStateFromLocalStorage(LocalStorageService.SESSION_USER_KEY);
    if (parseInt(localStorageUserId, 10) !== userId) {
      LocalStorageService.clearUserStorage();
    }
    storeAPI.dispatch(loadLocalUserStorage());
    LocalStorageService.saveStateToLocalStorage(LocalStorageService.SESSION_USER_KEY, userId);
  }

  return result;
};

export default localStorageMiddleware;
